import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
})

const getSystemTheme = () => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }
  return 'light'
}

// Initialize theme from localStorage or system settings
const initializeTheme = () => {
  const userSetMode = localStorage.getItem('theme-mode-user-set') === 'true'
  const savedMode = localStorage.getItem('theme-mode')
  if (userSetMode && (savedMode === 'light' || savedMode === 'dark')) {
    document.documentElement.classList.add(savedMode)
    localStorage.setItem('theme', savedMode)
    return
  }

  if (userSetMode && savedMode === 'system') {
    const systemTheme = getSystemTheme()
    document.documentElement.classList.add(systemTheme)
    localStorage.setItem('theme', systemTheme)
    return
  }

  // Default mode is system.
  localStorage.setItem('theme-mode', 'system')
  const systemTheme = getSystemTheme()
  localStorage.setItem('theme', systemTheme)
  document.documentElement.classList.add(systemTheme)
}

// Initialize theme before rendering
initializeTheme()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            className: 'bg-dark-200 text-white border border-dark-300',
            duration: 4000,
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
) 
